import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default function DialogCampanhaResultadoDetalhe({
  PaperComponent,
  open,
  onClose,
  resultadoSelecionado,
  resultadoLinhas,
  resultadoBeneficios,
  limparVendedor,
}) {
  return (
    <Dialog
      PaperComponent={PaperComponent}
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "calc(100% - 24px)", lg: "1100px" },
          maxWidth: "100%",
          m: { xs: 1.5, md: 3 },
        },
      }}
    >
      <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
        Detalhe: Fatura {resultadoSelecionado?.faturaorigem || ""}
        {resultadoSelecionado?.campanha || resultadoSelecionado?.codigo_campanha
          ? `, Campanha "${resultadoSelecionado?.campanha || ""}" (${
              resultadoSelecionado?.codigo_campanha || ""
            })`
          : ""}
      </DialogTitle>

      <DialogContent
        sx={{
          px: { xs: 1.5, md: 3 },
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        {resultadoSelecionado && (
          <MDBox
            display="grid"
            gap={2}
            mt={1}
            sx={{
              maxWidth: "100%",
            }}
          >
            <MDBox
              p={{ xs: 1.25, md: 2 }}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <MDTypography variant="h6" mb={1}>
                Resumo
              </MDTypography>

              <MDBox
                display="grid"
                gridTemplateColumns={{ xs: "1fr", sm: "1fr 1fr", lg: "1fr 1fr 1fr 1fr" }}
                gap={1}
              >
                <MDTypography variant="caption">
                  <b>Cliente:</b> {resultadoSelecionado.cliente || resultadoSelecionado.refcliente}
                </MDTypography>
                <MDTypography variant="caption">
                  <b>Vendedor:</b>{" "}
                  {limparVendedor(resultadoSelecionado.vendedor) ||
                    resultadoSelecionado.refvendedor}
                </MDTypography>
                <MDTypography variant="caption">
                  <b>Conjuntos:</b> {resultadoSelecionado.conjuntosdetetados}
                </MDTypography>
                <MDTypography variant="caption">
                  <b>Estado:</b> {resultadoSelecionado.estado}
                </MDTypography>
                <MDTypography variant="caption">
                  <b>Valor a receber:</b> {resultadoSelecionado.valor_a_receber}
                </MDTypography>
                <MDTypography variant="caption">
                  <b>Valor recebido:</b> {resultadoSelecionado.valor_total_recebido}
                </MDTypography>
                <MDTypography variant="caption">
                  <b>Oferta:</b>{" "}
                  {resultadoSelecionado.refmaterialoferta
                    ? `${resultadoSelecionado.qtd_oferta_a_receber || ""} ${
                        resultadoSelecionado.unidadeoferta || ""
                      } ${
                        resultadoSelecionado.materialoferta ||
                        resultadoSelecionado.refmaterialoferta
                      }`
                    : ""}
                </MDTypography>
              </MDBox>
            </MDBox>

            <MDBox
              p={{ xs: 1.25, md: 2 }}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <MDTypography variant="h6" mb={1}>
                Cliente
              </MDTypography>

              <MDBox
                display="grid"
                gridTemplateColumns={{ xs: "1fr", sm: "1fr 1fr", lg: "1fr 2fr 2fr 2fr" }}
                gap={1}
              >
                <MDTypography variant="caption">
                  <b>Ref.:</b> {resultadoSelecionado.refcliente}
                </MDTypography>
                <MDTypography variant="caption">
                  <b>Nome:</b> {resultadoSelecionado.cliente}
                </MDTypography>
                <MDTypography variant="caption">
                  <b>Rua:</b> {resultadoSelecionado.cliente_rua}
                </MDTypography>
                <MDTypography variant="caption">
                  <b>CP/Cidade:</b>{" "}
                  {[resultadoSelecionado.cliente_codigopostal, resultadoSelecionado.cliente_cidade]
                    .filter(Boolean)
                    .join(" ")}
                </MDTypography>
                <MDTypography variant="caption">
                  <b>NIF:</b> {resultadoSelecionado.cliente_nif}
                </MDTypography>
                <MDTypography variant="caption">
                  <b>Cliente:</b>{" "}
                  {[resultadoSelecionado.cliente_refgrupo, resultadoSelecionado.cliente_grupo]
                    .filter(Boolean)
                    .join(" — ")}
                </MDTypography>
                <MDTypography variant="caption">
                  <b>Seg. potencial:</b> {resultadoSelecionado.cliente_segmentopotencial}
                </MDTypography>
                <MDTypography variant="caption">
                  <b>Segmentos:</b>{" "}
                  {[
                    resultadoSelecionado.cliente_segmenton1,
                    resultadoSelecionado.cliente_segmenton2,
                    resultadoSelecionado.cliente_segmenton3,
                  ]
                    .filter(Boolean)
                    .join(" / ")}
                </MDTypography>
              </MDBox>
            </MDBox>

            <MDBox
              p={{ xs: 1.25, md: 2 }}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <MDTypography variant="h6" mb={1}>
                Linhas usadas no cálculo
              </MDTypography>

              <MDBox
                sx={{
                  maxHeight: { xs: "48vh", md: 260 },
                  overflow: "auto",
                  maxWidth: "100%",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    minWidth: 980,
                    borderCollapse: "collapse",
                  }}
                >
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Tipo</th>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Fatura</th>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Material</th>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Nome</th>
                      <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Qtd usada</th>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Unid.</th>
                      <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>
                        Preço un. líq.
                      </th>
                      <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Desc. base</th>
                      <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Desc. fatura</th>
                      <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Desc. camp.</th>
                    </tr>
                  </thead>

                  <tbody>
                    {resultadoLinhas.map((l) => (
                      <tr key={l.id}>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {l.tipoutilizacao}
                        </td>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {l.faturanumero}
                        </td>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {l.refmaterial}
                        </td>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {l.material}
                        </td>
                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "right",
                          }}
                        >
                          {l.qtd}
                        </td>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {l.qtdunid}
                        </td>
                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "right",
                          }}
                        >
                          {Number(l.precoliquidounitario || 0).toFixed(2)}
                        </td>
                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "right",
                          }}
                        >
                          {Number(l.descontopromocionalbase || 0).toFixed(2)}
                        </td>
                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "right",
                          }}
                        >
                          {Number(l.descprompercfatura || 0).toFixed(2)}
                        </td>
                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "right",
                          }}
                        >
                          {Number(l.descprommaxcampanha || 0).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </MDBox>
            </MDBox>

            <MDBox
              p={{ xs: 1.25, md: 2 }}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <MDTypography variant="h6" mb={1}>
                Benefícios
              </MDTypography>

              <table
                style={{
                  width: "100%",
                  minWidth: 720,
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Tipo</th>
                    <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Base</th>
                    <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>
                      Valor a receber
                    </th>
                    <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Valor recebido</th>
                    <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Oferta</th>
                    <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Estado</th>
                  </tr>
                </thead>

                <tbody>
                  {resultadoBeneficios.map((b) => (
                    <tr key={b.id}>
                      <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                        {b.tipobeneficio}
                      </td>
                      <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                        {b.basecalculo}
                      </td>
                      <td
                        style={{
                          fontSize: 12,
                          padding: 6,
                          borderTop: "1px solid #eee",
                          textAlign: "right",
                        }}
                      >
                        {Number(b.valor_a_receber || 0).toFixed(2)}
                      </td>
                      <td
                        style={{
                          fontSize: 12,
                          padding: 6,
                          borderTop: "1px solid #eee",
                          textAlign: "right",
                        }}
                      >
                        {Number(b.valor_total_recebido || 0).toFixed(2)}
                      </td>
                      <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                        {b.refmaterialoferta
                          ? `${b.qtd_oferta_a_receber || ""} ${b.unidadeoferta || ""} ${
                              b.materialoferta || b.refmaterialoferta
                            }`
                          : ""}
                      </td>
                      <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                        {b.estado}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </MDBox>
          </MDBox>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          flexWrap: "wrap",
          gap: 1,
          px: { xs: 2, md: 3 },
          pb: { xs: 2, md: 2 },
          "& .MuiButton-root": {
            width: { xs: "100%", sm: "auto" },
          },
        }}
      >
        <MDButton color="secondary" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
